import Storage from './Storage';

/**
 * Store AdditionalCharges
 * 
 */
class AdditionalCharges extends Storage {
    storeName = 'additional_charges_';
    hasOldKey = true;

    /**
     * AdditionalCharges constructor
     * 
     * @param {string} id location id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

}

export default AdditionalCharges;